var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-wrap"},[_c('first'),_c('our-advantage'),_c('business-process'),_c('high-praise')],1)}
var staticRenderFns = []

export { render, staticRenderFns }